import rg4js from "raygun4js";
import React from "react";
import LinkButton from "../Shared/Link/Link";
import {
  Container,
  ErrorDescription,
  ErrorHeader,
  ErrorMessage,
} from "./Styles";
import { SYN_REDIRECT } from "../../utility/constants";
import { Break } from "../Shared/Layout/Layout";

export default function ErrorPage(props) {
  const errorMessage = props.location?.state?.errorMessage;
  const errorDetails = props.location?.state?.errorDetails;

  // We need to have a nullcheck on the errorDetails constant - as above so below.

  rg4js("send", {
    error: errorMessage || "Landed on Error page",
    customData: {
      graphQLErrors: errorDetails?.graphQLErrors || "",
      networkError: errorDetails?.networkError || "",
      fullError: errorDetails?.fullError || "",
      contentProcessStatus: errorDetails?.contentProcessStatus || "",
      backupProcessStatus: errorDetails?.backupProcessStatus || "",
    },
  });

  window.analytics.page("Error");

  return (
    <Container>
      <ErrorHeader>Það kom villa upp</ErrorHeader>
      {errorMessage ? <ErrorMessage>{errorMessage}</ErrorMessage> : ""}
      <ErrorDescription style={{ maxWidth: "600px" }}>
        Óvænt villa kom upp. Ef þú lendir áfram í vandræðum getur þú haft
        samband við okkur í gegnum Netspjallið eða þjónustuver Sýnar í síma
        1414.
      </ErrorDescription>
      <Break />
      <LinkButton to={SYN_REDIRECT} label="Fara á syn.is" />
    </Container>
  );
}
